import { useEffect } from "react";
import { Typography, Box, Container, Fade } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../../assests/logo.png";

export default function Unauthorized() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container 
      maxWidth={false} 
      disableGutters 
      sx={{ 
        overflow: "hidden",
        height: "100vh",
        display: "flex",
        justifyContent: "center" 
      }}
    >
      <Fade in={true} timeout={800}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: { xs: 8, md: 12 }, 
            textAlign: "center",
            width: "100%",
            maxWidth: "500px",
            px: 3
          }}
        >
          <Box
            component="img"
            src={Logo}
            alt="logo"
            sx={{
              display: "block",
              width: { xs: 220, md: 300 },
              height: "auto",
              mb: 3,
              mx: "auto"
            }}
          />

          <Typography 
            variant="h5"
            component="h1" 
            gutterBottom 
            sx={{ fontWeight: "bold" }}
          >
            {t("SessionExpired")}
          </Typography>

          <Typography 
            variant="body2"
            color="text.secondary" 
            sx={{ mb: 3 }}
          >
            {t("RedirectToLoginPage")}
          </Typography>
        </Box>
      </Fade>
    </Container>
  );
}